import { JSX, useContext } from "react";
import { AttestedEntity } from "./models/attestedEntity";
import QdpAttestationGroup from "./QdpAttestationGroup";
import QdpAttestationRow from "./QdpAttestationRow";
/* oxlint-disable-next-line import/no-cycle */
import QdpEntityGroup from "./QdpEntityGroup";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import Features from "@app/feature-flags/features";

interface QdpAttestedEntityProps {
  entity: AttestedEntity;
  groupDepth: number;
  entityId: string;
  class: string;
  sourceId?: string;
  key?: number;
}

function getDirectoryFacingLabel(additionalProperties: { [name: string]: string }): string {
  const rawProperties = additionalProperties?.Properties;
  if (!rawProperties) return null;

  let parsedProperties: { DirectoryFacing?: string };
  try {
    parsedProperties = JSON.parse(rawProperties);
  } catch {
    return null;
  }

  switch (parsedProperties?.DirectoryFacing) {
    case "Y":
      return "Yes";
    case "N":
      return "No";
    default:
      return null;
  }
}

export default function QdpAttestedEntity(props: QdpAttestedEntityProps): JSX.Element {
  const { enabledFeatureFlags } = useContext(FeatureFlagContext);
  const directoryFacingLabel = enabledFeatureFlags.has(Features.ACCURACY_ENABLE_DIRECTORY_FACING)
    ? getDirectoryFacingLabel(props.entity?.AdditionalProperties)
    : null;

  return (
    <>
      <li className="list-group-item bordered" data-bs-toggle="collapse" data-bs-target={`#${props.entityId}`}>
        <div className={props.class}>
          <span className="expandable">{props.entity?.Name}</span>
        </div>
      </li>
      <div className="collapse" id={props.entityId}>
        {props.entity?.AdditionalProperties &&
          Object.keys(props.entity.AdditionalProperties).map((key, index) => (
            <QdpAttestationRow row={{ RecordStatus: props.entity.AdditionalProperties[key], Value: key }} rowDepth={(props.groupDepth).toString()} key={index} />))
        }
        {directoryFacingLabel &&
          <QdpAttestationRow row={{ RecordStatus: directoryFacingLabel, Value: "Directory Facing" }} rowDepth={(props.groupDepth).toString()} />
        }
        {props.entity &&
          props.entity.AttestationTypes.map((x, i) =>
            <QdpAttestationGroup entityXid={props.entity.Xid} attestation={x} key={i} groupDepth={props.groupDepth} sourceId={props.sourceId} />
          )}
        {props.entity.Locations &&
          <QdpEntityGroup entities={props.entity.Locations} dataId={`${props.entityId}-locations`} name="Locations" entityTag={`${props.entityId}`} groupDepth={props.groupDepth} index={props.key}/>}
      </div>
    </>
  );
}